module.exports = __webpack_public_path__ + "media/images/weather/partly-cloudy-a62b38d37320bd762942118f7834f372.jpg";